export default __webpack_public_path__ + "static/chidog-278218e3679727314e001ed0aa7a11d1.png";